<template>
  <div class="flex flex-col h-screen items-center justify-center">
    <div class="text-center">
      <h1 class="text-2xl font-bold mb-4">Processing Spotify Login...</h1>
      <div v-if="loading" class="flex justify-center">
        <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
      </div>
      <div v-if="error" class="text-red-500 mt-4">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { callback } from '@/config/api'

export default {
  name: 'SpotifyCallback',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    
    const loading = ref(true)
    const error = ref(null)
    
    onMounted(async () => {
      try {
        // Get the authorization code from the URL
        const code = route.query.code
        
        if (!code) {
          error.value = 'No authorization code received from Spotify'
          loading.value = false
          return
        }
        
        // Exchange the code for a token
        await store.dispatch('loginWithSpotify', {
          code,
          redirectUri: callback
        })
        
        // Redirect to home page
        router.push('/')
      } catch (err) {
        error.value = err.message || 'Failed to authenticate with Spotify'
        loading.value = false
      }
    })
    
    return {
      loading,
      error
    }
  }
}
</script>
